/* eslint-disable no-underscore-dangle */
import { useParams, Link } from 'react-router-dom';
import { BaseHelpCenterProps } from '../types';

export function HelpCenterBreadcrumbs({ helpCenterData }: BaseHelpCenterProps) {
  const { userId, sectionTitle, articleId } = useParams<{
    userId: string;
    sectionTitle: string;
    articleId: string;
  }>();

  const currentSection = helpCenterData?.sections.find(
    (s) => s.title.toLowerCase() === sectionTitle?.toLowerCase(),
  );

  const currentArticle = currentSection?.articles.find(
    (a) => a._id === articleId,
  );

  return (
    <nav aria-label="Breadcrumb" className="flex items-center mb-4 text-2xs">
      {articleId || sectionTitle ? (
        <div className="flex items-center">
          <Link
            to={`/users/${userId}/help-center`}
            className="nu-text-base-disabled hover:nu-text-base-primary inline-block py-1 px-2"
          >
            <span>Help Center</span>
          </Link>
          <span className="nu-text-base-disabled">/</span>
        </div>
      ) : (
        <span className="nu-text-base-primary py-1 px-2">Help Center</span>
      )}

      {sectionTitle && currentSection && (
        <div className="flex items-center">
          {articleId ? (
            <>
              <Link
                to={`/users/${userId}/help-center/${sectionTitle.toLowerCase()}`}
                className="nu-text-base-disabled hover:nu-text-base-primary inline-block py-1 px-2"
              >
                <span>{currentSection.title}</span>
              </Link>
              <span className="nu-text-base-disabled">/</span>
            </>
          ) : (
            <span className="nu-text-base-primary py-1 px-2">
              {currentSection.title}
            </span>
          )}
        </div>
      )}

      {articleId && currentArticle && (
        <span className="nu-text-base-primary py-1 px-2">
          {currentArticle.title}
        </span>
      )}
    </nav>
  );
}
